import React, { Fragment, useContext, useEffect, useState } from 'react';

import { WsDeliverConfigResourceItem, WsDeliverConfigSchemaItem, WsDeliverConfigSchemaMapping } from 'wsp-core/src/interfaces';

import { WsDeliverConfigItemType, WsDeliverConfigSchemaMappingStatus, WsDeliverConfigWorkload } from '../../../enums';


import { Loading } from "../../Shared";


import ReactApexChart from "react-apexcharts";



import { getWorkloadName } from "../data/deliver-data";

import { getWorkloadMappingCount, getWorkloadSchemaCount } from "./ResourcePage";




import './ConfigPage.scss';
import './ConfigTenant.scss';
import { IconButton, Panel, PanelType } from "office-ui-fabric-react";
import { getSchemaMappingList, resourceTypeIsResource, resourceTypeIsValue, startsWith } from "../data/mapping-data";










const WsWorkloadCoverageChart = (props: {
  legendVisible: boolean;
  mode:          string;
  workloadName:  string;
  countDsc:      number;
  countCustom:   number;
  countReview:   number;
  countMissing:  number;
  // setResourcePanelVisible: React.Dispatch<React.SetStateAction<string>>;
  workload: WsDeliverConfigWorkload;
  workloadDataList:  WsWorkloadData[];
  staticMappingList: WsDeliverConfigSchemaMapping[];
}) => {

  const [ resourcePanelVisible, setResourcePanelVisible ] = useState<string>('');

  const onClickSeries = (seriesIndex: number) => {
    if (seriesIndex === 0) {
      console.log('managed clicked');
      setResourcePanelVisible('MANAGED');
    } else {
      console.log('unmanaged clicked');
      setResourcePanelVisible('UNMANAGED');
    }
  };

  const countTotal = props.countDsc + props.countCustom + props.countMissing;

  const options: ApexCharts.ApexOptions = {

    // title: {
    //   text: 'Resources'
    // },

    legend: {
      show: props.legendVisible,
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40
    },

    colors: [
      '#ff943d', // total
      '#06a006', // mapped
      '#3b3bba', // review
      // '#C80100'  // missing
      // '#a1a1a1', // ignore
      // '#8ba5ff', // read only
    ],

    chart: {
      type: 'bar',
      // height: 350,
      stacked: true,
      toolbar: {
        show: false
      },
      events: {
        dataPointSelection: function(event, chartContext, config) {
          // The 'config' object contains the selected data

          onClickSeries(config.seriesIndex);

          // console.log(chartContext);
          // console.log(config.seriesIndex);

          // console.log('Clicked on bar:', config.w.config.series[config.seriesIndex].data[config.dataPointIndex]);

          // alert('Bar clicked: ' + config.w.config.series[config.seriesIndex].data[config.dataPointIndex]);
        }
      }
    },

    plotOptions: {
      bar: {
        horizontal: true
      },
    },

    stroke: {
      width: 1,
      colors: [ '#fff' ]
    },

    xaxis: {
      categories: [ `` ],
      min: 0,
      max: countTotal > 0 ? countTotal : 100,
      tickAmount: 5
    },

    yaxis: {
      title: {
        text: undefined
      },
      axisTicks: {
        show: false
      }
    },

    fill: {
      opacity: 1
    }
  };

  const series: any  = [
    // {
    //   name: 'Total',
    //   group: 'total',
    //   data: [
    //     100
    //   ]
    // },
    {
      name: 'Managed',
      // group: 'split',
      data: [
        props.countDsc
      ]
    },
    {
      name: 'Managed (Custom)',
      // group: 'split',
      data: [
        props.countCustom
      ]
    // }, {
    //   name: 'In Review (PowerShell)',
    //   // group: 'split',
    //   data: [
    //     props.countReview
    //   ]
    }, {
      name: 'Unmanaged',
      // group: 'split',
      data: [
        props.countMissing
      ]
    }
  ];

  return (
    <>
      <tr>
        <td style={{ paddingTop: '40px', width: '170px', fontSize: '12px', fontWeight: 600 }}>
          {props.workloadName}<br />({props.mode})
        </td>
        <td style={{ paddingTop: 0, paddingBottom: 0 }}>
          <ReactApexChart
            series={series}
            options={options}
            type="bar"
            height={props.legendVisible ? 130 : 105}
          />
        </td>
      </tr>
      {
        resourcePanelVisible
        &&
        <WsResourceListPanel
          mode={props.mode}
          workloadName={props.workloadName}
          workload={props.workload}
          workloadDataList={props.workloadDataList}
          staticMappingList={props.staticMappingList}
          resourcePanelVisible={resourcePanelVisible}
          setResourcePanelVisible={setResourcePanelVisible}
        />
      }
    </>
  );
};














const pushConfigSchemaItem = (configSchemaList: WsDeliverConfigSchemaItem[], configSchemaItem: WsDeliverConfigSchemaItem) => {

  const findConfigSchemaItem = configSchemaList.find((item) => item.schemaPath === configSchemaItem.schemaPath);

  if (!findConfigSchemaItem) {
    configSchemaList.push(configSchemaItem);
  }
};




const filterSchemaList = (resourceTypeName: string, resourceCategory: string, workloadDataItem: WsWorkloadData, staticMappingList: WsDeliverConfigSchemaMapping[]) => {

  const data = resourceCategory === 'MANAGED' ? workloadDataItem.dscData : workloadDataItem.sourceData;

  if (resourceCategory === 'MANAGED') {

    // if (resourceTypeName === 'FIELDS') {
    //   return data;
    // } else {
    //   return data.filter((item) => resourceTypeIsResource(item.type));
    // }

    return data;

  } else {

    const filteredData: WsDeliverConfigSchemaItem[] = [];

    const schemaMappingList = getSchemaMappingList(workloadDataItem.sourceData, workloadDataItem.dscData, staticMappingList);



    // get missing schema items

    const missingList = data.filter((schemaItem) => {

      if (resourceTypeName === 'FIELDS') {
        // fields

        if (resourceTypeIsValue(schemaItem.type)) {

          const mappingItem = schemaMappingList.find((item) => item.sourcePath === schemaItem.schemaPath);

          if (mappingItem?.status === WsDeliverConfigSchemaMappingStatus.Missing) {
            return true;
          } else {
            return false;
          }

        } else {
          return false;
        }

      } else {
        // resources

        if (resourceTypeIsResource(schemaItem.type)) {

          const findItem = schemaMappingList.find((item) => item.sourcePath === schemaItem.schemaPath);

          if (findItem?.status === WsDeliverConfigSchemaMappingStatus.Missing) {
            return true;
          } else {
            return false;
          }

        } else {
          return false;
        }
      }

    });

    // push missing schema items

    filteredData.push(...missingList);



    // get parent items for missing schema items

    const parentList = data.filter((schemaItem) => {

      const findChild = missingList.find((item) => startsWith(item.schemaPath, schemaItem.schemaPath)); // && item.schemaPath.toLowerCase() !== schemaItem.schemaPath.toLowerCase()

      if (findChild) {

        if (resourceTypeName === 'FIELDS') {
          return true;
        } else {
          return resourceTypeIsResource(schemaItem.type);
        }

      } else {
        return false;
      }
    });


    parentList.forEach((schemaItem) => {
      pushConfigSchemaItem(filteredData, schemaItem);
    });




    // return

    return filteredData.sort((a, b) => {
      if (a.schemaPath.toLowerCase() < b.schemaPath.toLowerCase()) return -1;
      if (a.schemaPath.toLowerCase() > b.schemaPath.toLowerCase()) return  1;
      return 0;
    });
  }
};





const WsResourceListPanel = (props: {
  mode:                    string;
  workloadName:            string;
  workload:                WsDeliverConfigWorkload;
  workloadDataList:        WsWorkloadData[];
  staticMappingList:       WsDeliverConfigSchemaMapping[];
  resourcePanelVisible:    string;
  setResourcePanelVisible: React.Dispatch<React.SetStateAction<string>>;
}) => {

  const workloadDataItem = props.workloadDataList.find((item) => item.workload === props.workload);

  if (workloadDataItem) {

    const dataFiltered = filterSchemaList(props.mode.toUpperCase(), props.resourcePanelVisible, workloadDataItem, props.staticMappingList);

    return (
      <Panel
        customWidth="550px"
        isBlocking={false}
        isOpen={true}
        onDismiss={() => {
          props.setResourcePanelVisible('');
        }}
        type={PanelType.custom}
        headerText={`${props.workloadName} (${props.resourcePanelVisible.toLowerCase()} ${props.mode.toLowerCase()})`}
      >
        {/* <h2 className="title is-4">{props.workloadName} ({props.resourcePanelVisible.toLowerCase()} {props.mode.toLowerCase()})</h2> */}
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Resource</th>
              <th>Ref</th>
            </tr>
          </thead>
          <tbody>
            {
              dataFiltered.map((configSchemaItem, index) => {



                // level

                let level = configSchemaItem.schemaPath.split('/').length - 4;

                if (level < 0) {
                  level = 0;
                }

                if (props.resourcePanelVisible.toUpperCase() === 'UNMANAGED' && props.mode.toUpperCase() !== 'FIELDS') {
                  level = 0;
                }



                // padding

                const paddingLeft = 9 + (level * 21);



                return (
                  <tr key={`ws-item-${index}`}>
                    <td
                      style={{
                        paddingLeft: `${paddingLeft + 21}px`
                      }}
                    >
                      {configSchemaItem.name}
                      {/* ({configSchemaItem.type}) */}
                    </td>
                    <td>
                      {
                        props.resourcePanelVisible.toUpperCase() === 'UNMANAGED'
                        &&
                        resourceTypeIsResource(configSchemaItem.type)
                        &&
                        <>
                          <IconButton
                            iconProps={{ iconName: 'OpenInNewTab' }}
                            // href={`https://learn.microsoft.com/en-us/powershell/module/${getMsDocType(configSchemaItem.name, props.workload)}/get-${configSchemaItem.name.toLowerCase()}${getMsDocView(props.workload)}`}
                            href={`https://learn.microsoft.com/en-gb/search/?terms="Get-${configSchemaItem.name}"`}
                            target="_blank"
                          />
                          <IconButton
                            iconProps={{ iconName: 'Search' }}
                            href={`https://learn.microsoft.com/en-gb/search/?terms="Set-${configSchemaItem.name}"%20"Add-${configSchemaItem.name}"`}
                            target="_blank"
                          />
                        </>
                      }
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </Panel>
    );

  } else {
    return (<></>);
  }
};







// https://learn.microsoft.com/en-us/powershell/module/microsoft.graph.devices.corporatemanagement/get-mgdeviceappmanagementmobileapp?view=graph-powershell-1.0

// https://learn.microsoft.com/en-us/powershell/module/microsoft.graph.devices.corporatemanagement/get-MgBetaDeviceAppManagementMobileApp

const getMsDocType = (name: string, workload: WsDeliverConfigWorkload) => {
  if (workload === WsDeliverConfigWorkload.EntraId) {
    return 'microsoft.graph.entra';
    
  } else if (workload === WsDeliverConfigWorkload.Exchange) {
    return 'exchange';

  } else if (workload === WsDeliverConfigWorkload.Intune) {

    if (name.toLowerCase().indexOf('beta')) {
      return 'microsoft.graph.beta.devices.corporatemanagement';
    } else {
      return 'microsoft.graph.devices.corporatemanagement';
    }

  } else {
    return '';
  }
};

const getMsDocView = (workload: WsDeliverConfigWorkload) => {
  if (workload === WsDeliverConfigWorkload.EntraId) {
    return '?view=entra-powershell';
    
  } else if (workload === WsDeliverConfigWorkload.Exchange) {
    return '?view=exchange-ps';

  } else {
    return '';
  }
};









const WsResourceCoverage = (props: {
  workloadDataList: WsWorkloadData[];
  staticMappingList: WsDeliverConfigSchemaMapping[];
}) => {

  // console.log(props.workloadDataList);

  // const [ resourcePanelVisible, setResourcePanelVisible ] = useState<string>('');

  return (
    <>
      <div className="ws-deliver-coverage-legend">
        {/* <div className="ws-deliver-coverage-legend-item ws-managed">Managed (DSC Core)</div>
        <div className="ws-deliver-coverage-legend-item ws-managed">Managed (Custom)</div> */}
        <div className="ws-deliver-coverage-legend-item ws-managed">Managed (read/write)</div>
        <div className="ws-deliver-coverage-legend-item ws-unmanaged-write">Unmanaged (read with potential to write)</div>
        {/* <div className="ws-deliver-coverage-legend-item ws-unmanaged-read">Unmanaged (Unavailable)</div> */}
      </div>

      <table className="table is-fullwidth">
        <tbody>
          {
            props.workloadDataList.map((workloadDataItem, index) => {
              return (
                <Fragment key={`ws-workload-${workloadDataItem.workload.toLowerCase()}`}>
                  <WsWorkloadCoverageChart
                    mode="Resources"
                    legendVisible={false}
                    workloadName={getWorkloadName(workloadDataItem.workload)}
                    countDsc={getWorkloadSchemaCount(props.workloadDataList, props.staticMappingList, 'dscData', 'Resources', workloadDataItem.workload)}
                    countCustom={0}
                    countReview={getWorkloadMappingCount(props.workloadDataList, props.staticMappingList, 'Resources', workloadDataItem.workload, WsDeliverConfigSchemaMappingStatus.Review)}
                    countMissing={getWorkloadMappingCount(props.workloadDataList, props.staticMappingList, 'Resources', workloadDataItem.workload, WsDeliverConfigSchemaMappingStatus.Missing)}
                    // setResourcePanelVisible={setResourcePanelVisible}
                    workload={workloadDataItem.workload}
                    workloadDataList={props.workloadDataList}
                    staticMappingList={props.staticMappingList}
                  />
                  <WsWorkloadCoverageChart
                    mode="Fields"
                    legendVisible={false}
                    workloadName={getWorkloadName(workloadDataItem.workload)}
                    countDsc={getWorkloadSchemaCount(props.workloadDataList, props.staticMappingList, 'dscData', 'Fields', workloadDataItem.workload)}
                    countCustom={0}
                    countReview={getWorkloadMappingCount(props.workloadDataList, props.staticMappingList, 'Fields', workloadDataItem.workload, WsDeliverConfigSchemaMappingStatus.Review)}
                    countMissing={getWorkloadMappingCount(props.workloadDataList, props.staticMappingList, 'Fields', workloadDataItem.workload, WsDeliverConfigSchemaMappingStatus.Missing)}
                    // setResourcePanelVisible={setResourcePanelVisible}
                    workload={workloadDataItem.workload}
                    workloadDataList={props.workloadDataList}
                    staticMappingList={props.staticMappingList}
                  />
                </Fragment>
              );
            })
          }
        </tbody>
      </table>
    </>
  );
};




export {
  WsResourceCoverage
};

export interface WsWorkloadData {
  workload:   WsDeliverConfigWorkload;
  sourceData: WsDeliverConfigSchemaItem[];
  dscData:    WsDeliverConfigSchemaItem[];
};
